import React, { FC, useState } from "react";

import { Link } from "kanopi-components/Link";
import { SummaryTable } from "./SummaryTable";
import { navigate } from "@reach/router";
import { useFormatter } from "kw/util/useFormatter";

type TAdminQuoteSummarySection = {
  quote: TQuote;
};
export const AdminQuoteSummarySection: FC<TAdminQuoteSummarySection> = ({ quote }) => {
  const { formatDateTime, formatDate, formatString } = useFormatter();
  const customerFullName =
    `${quote?.riskProfile?.owner?.firstName} ${quote?.riskProfile?.owner?.lastName}`.trim();
  const isLazyUser = quote?.riskProfile?.owner?.isLazy;
  const contactEmail = quote?.riskProfile?.owner?.contactEmail;

  const quoteDetails = [
    {
      id: "id",
      label: "Quote ID",
      value: formatString(quote?.id),
    },
    {
      id: "customer",
      label: "Customer",
      value:
        !isLazyUser || contactEmail ? (
          <Link
            title={customerFullName}
            onClick={() =>
              navigate(`/admin/customers/${quote?.riskProfile?.owner?.id}`)
            }
          >
            {formatString(customerFullName)}
          </Link>
        ) : (
          "-"
        ),
    },
    {
      id: "startDate",
      label: "Start date",
      value: formatDate(quote?.startDate),
    },
    {
      id: "finishDate",
      label: "End date",
      value: formatDate(quote?.finishDate),
    },
    {
      id: "paymentFrequency",
      label: "Payment frequency",
      value: formatString(quote?.paymentFrequency),
    },
    {
      id: "insurer",
      label: "Insurer",
      value: formatString(quote?.product?.provider?.name),
    },
    {
      id: "product",
      label: "Product",
      value: formatString(quote?.product?.name),
    },
    {
      id: "status",
      label: "Status",
      value: formatString(quote?.stateDisplay),
    },
    {
      id: "referral_status",
      label: "Referral Status",
      value: formatString(quote?.referralStateDisplay),
    },
    {
      id: "created",
      label: "Created",
      value: formatDateTime(quote?.createdTimestamp),
    },
    {
      id: "updated",
      label: "Updated",
      value: formatDateTime(quote?.updatedTimestamp),
    },
    {
      id: "dp",
      label: "Distribution partner",
      value: formatString(quote?.distributionPartner?.name),
    },
  ];

  return <SummaryTable data={quoteDetails} type="QUOTE" />;
};
